import { reactive } from 'vue';
import { Options, Vue } from 'vue-class-component';
import Toggle from '@vueform/toggle';

import * as PriceListService from '@/services/price-list.service';
import * as ProductTypeService from '@/services/product-type.service';
import { IList } from '@/domain/list.model';
import { IProductType } from '@/domain/product-type.model';

@Options({
  name: 'price-list-new',
  components: {
    Toggle,
  },
})
export default class PriceListNew extends Vue {
  public errorMessage = '';
  public errors: any = {};
  public hasError = false;
  public productTypes: IList[] = reactive([]);
  public row = {
    name: '',
    description: '',
    price: '',
    product_type: 0,
    enabled: true,
  };

  public created(): void {
    ProductTypeService.listActive()
      .then((res: IProductType[]) => {
        this.productTypes = res.map((i) => {
          return { id: i.id, description: i.description };
        });
      });
  }

  public goBack() {
    this.$router.push('/price-list');
  }

  public validation() {
    this.errors = {};
    this.hasError = false;

    if (!this.row.name) {
      this.errors.name = 'Este campo deve ser preenchido.';
      this.hasError = true;
    }

    if (!this.row.price) {
      this.errors.price = 'Este campo deve ser preenchido.';
      this.hasError = true;
    }

    if (!this.row.product_type) {
      this.errors.product_type = 'Este campo deve ser preenchido.';
      this.hasError = true;
    }

    if (!this.row.description) {
      this.errors.description = 'Este campo deve ser preenchido.';
      this.hasError = true;
    }

    return !this.hasError;
  }

  public save() {
    if (this.validation()) {
      PriceListService.insert({
        name: this.row.name,
        description: this.row.description,
        price: parseFloat(this.row.price),
        product_type: this.row.product_type,
        enabled: this.row.enabled,
      })
        .then(() => {
          this.$router.push('/price-list');
        })
        .catch(() => {
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.';
        });
    }
  }
}
